import { DatePipe, formatNumber } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataSourcesService } from './data-sources.service';
@Injectable({
  providedIn: 'root'
})
export class AsicIntegerationService {

  constructor(private dataSourceService: DataSourcesService,
    private datePipe: DatePipe,
    private http: HttpClient) { }

  getCitizenInfo(apiId, payload: { dob?: string, nationalId: string }) {
    let citizinInfoData = {
      sNationalId: payload.nationalId,
      nCompanyID: '1',
      dCustBirthDate: payload.dob ? payload.dob : '',
      inputType: ['sNationalId', 'nCompanyID', 'dCustBirthDate']
    }

    return this.dataSourceService.invokeDataSource(apiId, citizinInfoData);
  }

  fillLeadData(form, yaqeenUserInfo, registrationtype, Data?) {
    Data = Data || {};
    yaqeenUserInfo = yaqeenUserInfo || {};
    let DateVal = null;

    if (form.controls.birthdate) {
      DateVal = (form.controls.birthdate.value instanceof Date) ? form.controls.birthdate.value :
        form.controls.birthdate.value._d || form.controls.birthdate.value;
    } else if (form.controls.dateOfBirth) {
      DateVal = (form.controls.dateOfBirth.value instanceof Date) ? form.controls.dateOfBirth.value :
        form.controls.dateOfBirth.value._d || form.controls.dateOfBirth.value;
    }

    if (DateVal && !(DateVal instanceof Date)) {
      if (DateVal.includes('/'))
        DateVal = this.datePipe.transform(new Date(DateVal.split('/').reverse().join("-")), 'dd/MM/yyyy');
      else
        DateVal = this.datePipe.transform(new Date(DateVal.split('-').reverse().join("-")), 'dd/MM/yyyy');
    }

    if (!DateVal)
      DateVal = (yaqeenUserInfo && yaqeenUserInfo.dateOfBirthGField) ?
        this.datePipe.transform(yaqeenUserInfo.dateOfBirthGField, 'dd/MM/yyyy') : null;

    const hijriControl = form.controls['isHijri'];
    let isHijri = false;
    if (hijriControl && !!hijriControl.value) {
      isHijri = hijriControl.value;
    }

    if (Data.BIRTH_DATE && isHijri)
      DateVal = Data.BIRTH_DATE;

    let nationalId = null;
    let SponsorID = null;
    if ((form.controls.isIndividual && form.controls.isIndividual.value)
      || registrationtype == 1) {

      if (form.controls.nationalId) {
        nationalId = form.controls.nationalId.value;
      } else if (form.controls.saudiIqamaId) {
        nationalId = form.controls.saudiIqamaId.value;
      } else if (form.controls.registrationId) {
        nationalId = form.controls.registrationId.value;
      }
    } else {
      if (form.controls.SponsorID) {
        SponsorID = form.controls.SponsorID.value;
      }
      else if (form.controls.nationalId) {
        SponsorID = form.controls.nationalId.value;
      } else if (form.controls.saudiIqamaId) {
        SponsorID = form.controls.saudiIqamaId.value;
      } else if (form.controls.registrationId) {
        SponsorID = form.controls.registrationId.value;
      }
    }


    let getLeadDSparams: any = {
      ACCOUNT_ID: Data.ACCOUNT_ID ? Data.ACCOUNT_ID : '',
      CRG_COM_ID: Data.CRG_COM_ID ? Data.CRG_COM_ID : '1',
      CRG_BRN_ID: Data.CRG_BRN_ID ? Data.CRG_BRN_ID : '',
      ACCOUNT_TYPE: Data.ACCOUNT_TYPE ? Data.ACCOUNT_TYPE : (registrationtype === 1) ? '1' : '2',
      ACCOUNT_NAME: form.controls.fullName.value ? form.controls.fullName.value : (Data.ACCOUNT_NAME || ''),
      // NATIONAL_ID: (!Data.ACCOUNT_ID) ? Data.NATIONAL_ID ? Data.NATIONAL_ID : (form.controls.nationalId ? form.controls.nationalId.value : form.controls.saudiIqamaId.value || '') : '',
      // COMMERCIAL_REG: (!Data.ACCOUNT_ID) ? Data.COMMERCIAL_REG ? Data.COMMERCIAL_REG : (form.controls.nationalId ? form.controls.nationalId.value : form.controls.saudiIqamaId.value || '') : '',
      NATIONAL_ID: Data.NATIONAL_ID ? Data.NATIONAL_ID : nationalId || '',

      COMMERCIAL_REG: Data.COMMERCIAL_REG ? Data.COMMERCIAL_REG : SponsorID || '',

      PREFIX: Data.PREFIX ? Data.PREFIX : '0',
      BIRTH_DATE: !!DateVal ? DateVal : (Data.BIRTH_DATE || ''),
      EMAIL: form.controls.email ? form.controls.email.value : (Data.EMAIL || ''),
      COUNTRY: Data.COUNTRY ? Data.COUNTRY : '',
      COUNTRY_NAME: Data.COUNTRY_NAME ? Data.COUNTRY_NAME : '',
      CITY: Data.CITY ? Data.CITY : '',
      CITY_NAME: Data.CITY_NAME ? Data.CITY_NAME : '',
      CRM_BSE_ID: Data.CRM_BSE_ID ? Data.CRM_BSE_ID : '719',
      PHONE_NUMBER: form.controls.phoneNumber ? form.controls.phoneNumber.value : (Data.PHONE_NUMBER || ''),
      MOBILE_NUMBER: form.controls.phoneNumber ? form.controls.phoneNumber.value : (Data.MOBILE_NUMBER || ''),
      POBOX: Data.POBOX ? Data.POBOX : '',
      MARITAL_STATUS_NAME: Data.MARITAL_STATUS_NAME ? Data.MARITAL_STATUS_NAME : '',
      PASSPORT: Data.PASSPORT ? Data.PASSPORT : '',
      NATIONALITY: Data.NATIONALITY ? Data.NATIONALITY : '',
      NATIONALITY_NAME: Data.NATIONALITY_NAME ? Data.NATIONALITY_NAME : '',
      MOBILE_NUMBER2: Data.MOBILE_NUMBER2 ? Data.MOBILE_NUMBER2 : '',
      AREA: Data.AREA ? Data.AREA : '',
      STREET: Data.STREET ? Data.STREET : '',
      ADDRESS: Data.ADDRESS ? Data.ADDRESS : '',
      // BUILDING_NO: this.yaqeenAddressData.buildingNumber ? this.yaqeenAddressData.buildingNumber : (Data.BUILDING_NO || ''),
      BUILDING_NO: Data.BUILDING_NO ? Data.BUILDING_NO : '',
      FLOOR: Data.FLOOR ? Data.FLOOR : '',
      JOB_TITLE: Data.JOB_TITLE ? Data.JOB_TITLE : '',
      TRAFFIC_CODE: Data.TRAFFIC_CODE ? Data.TRAFFIC_CODE : '',
      DRIVER_LICENSE_ID: Data.DRIVER_LICENSE_ID ? Data.DRIVER_LICENSE_ID : '',
      CURR_INS_COM: Data.CURR_INS_COM ? Data.CURR_INS_COM : '',
      CURR_INS_EXP_DATE: Data.CURR_INS_EXP_DATE ? Data.CURR_INS_EXP_DATE : '',
      AR_CUSTOMER_ID: Data.AR_CUSTOMER_ID ? Data.AR_CUSTOMER_ID : '',
      Salary: Data.SALARY ? Data.SALARY : '0',
      VAT: Data.VAT ? Data.VAT : '',
      CUSTOMER_LOCATION: Data.CUSTOMER_LOCATION ? Data.CUSTOMER_LOCATION : '',
      ADDITIONAL_CODE: Data.ADDITIONAL_CODE ? Data.ADDITIONAL_CODE : '',
      // DISTRICT: this.yaqeenAddressData.district ? this.yaqeenAddressData.district : (Data.DISTRICT || ''),
      DISTRICT: Data.DISTRICT ? Data.DISTRICT : '',
      POSTAL_CODE: Data.POSTAL_CODE ? Data.POSTAL_CODE : '',
      // POSTAL_CODE: this.yaqeenAddressData.postCode ? this.yaqeenAddressData.postCode : (Data.POSTAL_CODE || ''),
      LEAD_STREET: Data.LEAD_STREET ? Data.LEAD_STREET : '',
      LEAD_BUILDING_NO: Data.LEAD_BUILDING_NO ? Data.LEAD_BUILDING_NO : '',
    }

    if (!!yaqeenUserInfo) {
      getLeadDSparams.FIRST_NAME = yaqeenUserInfo.englishFirstNameField ? yaqeenUserInfo.englishFirstNameField : '';
      getLeadDSparams.MIDDLE_NAME = yaqeenUserInfo.englishSecondNameField ? yaqeenUserInfo.englishSecondNameField : '';
      getLeadDSparams.LAST_NAME = yaqeenUserInfo.englishLastNameField ? yaqeenUserInfo.englishLastNameField : '';
      getLeadDSparams.MARITAL_STATUS = yaqeenUserInfo.Marital_Status ? yaqeenUserInfo.Marital_Status : '';
      getLeadDSparams.GENDER = yaqeenUserInfo.genderField ? yaqeenUserInfo.genderField : (Data.GENDER || '');
      getLeadDSparams.GENDER_NAME = yaqeenUserInfo.genderField == 1 ? 'male' : 'female';
    }
    return getLeadDSparams
  }



  fillNewCRMLeadData(form, yaqeenUserInfo, registrationtype, Data?, CRM_BSE_ID?) {
    Data = Data || {};
    yaqeenUserInfo = yaqeenUserInfo || {};
    let DateVal = null;

    if (form.controls.birthdate) {
      DateVal = form.controls.birthdate.value ?
        ((form.controls.birthdate.value instanceof Date) ? form.controls.birthdate.value :
          form.controls.birthdate.value._d ? form.controls.birthdate.value._d : form.controls.birthdate.value) : null;
    } else if (form.controls.dateOfBirth) {
      DateVal = form.controls.dateOfBirth.value ?
        ((form.controls.dateOfBirth.value instanceof Date) ? form.controls.dateOfBirth.value :
          form.controls.birthdate.value._d ? form.controls.birthdate.value._d : form.controls.dateOfBirth.value) : null;
    }

    if (DateVal) {
      if ((DateVal instanceof Date)) {
        DateVal = this.datePipe.transform(new Date(DateVal).toISOString(), 'dd/MM/yyyy');
      } else {
        if (DateVal.includes('/'))
          DateVal = this.datePipe.transform(new Date(DateVal.split('/').reverse().join("-")), 'dd/MM/yyyy');
        else
          DateVal = this.datePipe.transform(new Date(DateVal.split('-').reverse().join("-")), 'dd/MM/yyyy');
      }
    }

    if (!DateVal)
      DateVal = (yaqeenUserInfo && yaqeenUserInfo.dateOfBirthGField) ?
        this.datePipe.transform(yaqeenUserInfo.dateOfBirthGField, 'dd/MM/yyyy') : null;

    const hijriControl = form.controls['isHijri'];
    let isHijri = false;
    if (hijriControl && !!hijriControl.value) {
      isHijri = hijriControl.value
    }

    let nationalId = null;
    let SponsorID = null;
    if ((form.controls.isIndividual && form.controls.isIndividual.value)
      || registrationtype == 1) {

      if (form.controls.nationalId) {
        nationalId = form.controls.nationalId.value;
      } else if (form.controls.saudiIqamaId) {
        nationalId = form.controls.saudiIqamaId.value;
      } else if (form.controls.registrationId) {
        nationalId = form.controls.registrationId.value;
      }
    } else {
      if (form.controls.SponsorID) {
        SponsorID = form.controls.SponsorID.value;
      }
      else if (form.controls.nationalId) {
        SponsorID = form.controls.nationalId.value;
      } else if (form.controls.saudiIqamaId) {
        SponsorID = form.controls.saudiIqamaId.value;
      } else if (form.controls.registrationId) {
        SponsorID = form.controls.registrationId.value;
      }
    }

    let phoneNumber = form.controls.phoneNumber ? form.controls.phoneNumber.value : (Data.PHONE_NUMBER || '');
    if (!form.controls.isIndividual.value && form.controls.corporatePhoneNumber && form.controls.corporatePhoneNumber.value) {
      phoneNumber = form.controls.corporatePhoneNumber.value;
    }

    const truncatedPhoneNumber = phoneNumber ? `0${phoneNumber.slice(3)}` : '';

    let getLeadDSparams: any = {
      ACCOUNT_ID: Data.ACCOUNT_ID ? +Data.ACCOUNT_ID : null,
      FCS_CST_ID: Data.FCS_CST_ID ? +Data.FCS_CST_ID : null,
      ACCOUNT_NAME: form.controls.fullName.value ? form.controls.fullName.value : (Data.ACCOUNT_NAME || ''),
      ACCOUNT_TYPE: Data.ACCOUNT_TYPE ? +Data.ACCOUNT_TYPE : (registrationtype === 1) ? 1 : 2,
      COUNTRY: Data.COUNTRY ? Data.COUNTRY : '',
      CITY: Data.CITY ? +Data.CITY : null,
      PHONE_NUMBER: truncatedPhoneNumber,
      CRG_COM_ID: Data.CRG_COM_ID ? +Data.CRG_COM_ID : 1,
      ADDRESS: Data.ADDRESS ? Data.ADDRESS : '',
      EMAIL: form.controls.email ? form.controls.email.value : (Data.EMAIL || ''),
      CRM_BSE_ID: Data.CRM_BSE_ID ? +Data.CRM_BSE_ID : CRM_BSE_ID || 1,
      NATIONAL_ID: Data.NATIONAL_ID ? Data.NATIONAL_ID : nationalId || '',
      BIRTH_DATE: !!DateVal ? DateVal : (Data.BIRTH_DATE || ''),
      GENDER: Data.GENDER ? +Data.GENDER : null,
      MARITAL_STATUS: Data.MARITAL_STATUS ? +Data.MARITAL_STATUS : null,
      PASSPORT: Data.PASSPORT ? Data.PASSPORT : '',
      NATIONALITY: Data.NATIONALITY ? Data.NATIONALITY : '',
      COMMERCIAL_REG: Data.COMMERCIAL_REG ? Data.COMMERCIAL_REG : SponsorID || '',
      FIRST_NAME: Data.FIRST_NAME ? Data.FIRST_NAME : '',
      MIDDLE_NAME: Data.MIDDLE_NAME ? Data.MIDDLE_NAME : '',
      LAST_NAME: Data.LAST_NAME ? Data.LAST_NAME : '',
      MOBILE_NUMBER: phoneNumber ? phoneNumber : (Data.MOBILE_NUMBER || ''),
      MOBILE_NUMBER2: phoneNumber ? phoneNumber : (Data.MOBILE_NUMBER2 || ''),
      PREFIX: Data.PREFIX ? +Data.PREFIX : null,
      POBOX: Data.POBOX ? Data.POBOX : '',
      BUILDING_NO: Data.BUILDING_NO ? Data.BUILDING_NO : '',
      FLOOR: Data.FLOOR ? Data.FLOOR : '',
      AREA: Data.AREA ? Data.AREA : '',
      STREET: Data.STREET ? Data.STREET : '',
      CURR_INS_EXP_DATE: Data.CURR_INS_EXP_DATE ? Data.CURR_INS_EXP_DATE : '',
      DISTRICT: Data.DISTRICT ? Data.DISTRICT : '',
      POSTAL_CODE: Data.POSTAL_CODE ? Data.POSTAL_CODE : '',
      BUS_ADR_CRG_CTY_CODE: Data.BUS_ADR_CRG_CTY_CODE ? +Data.BUS_ADR_CRG_CTY_CODE : null,
      BUS_ADR_ADDITIONAL_CODE: Data.BUS_ADR_ADDITIONAL_CODE ? Data.BUS_ADR_ADDITIONAL_CODE : '',
      BUS_ADR_Education: Data.BUS_ADR_Education ? +Data.BUS_ADR_Education : null,
      BUS_ADR_Profession: Data.BUS_ADR_Profession ? +Data.BUS_ADR_Profession : null,
      NO_OF_EMPLOYEES: Data.NO_OF_EMPLOYEES ? +Data.NO_OF_EMPLOYEES : null,
      CoreToken: Data.CoreToken ? Data.CoreToken : '',
      FAX: Data.FAX ? Data.FAX : '',
      PHONE_NUMBER2: truncatedPhoneNumber ? truncatedPhoneNumber : (Data.PHONE_NUMBER2 || ''),
      SEGMENT_CODE: Data.SEGMENT_CODE ? Data.SEGMENT_CODE : '',
      ACCOUNT_NAME2: form.controls.fullName.value ? form.controls.fullName.value : (Data.ACCOUNT_NAME2 || ''),
      CREATED_BY: Data.CREATED_BY ? Data.CREATED_BY : '',
      IS_VIP: Data.IS_VIP ? +Data.IS_VIP : null,
      ON_HOLD: Data.ON_HOLD ? +Data.ON_HOLD : 0,
      BLACK_LIST: Data.BLACK_LIST ? +Data.BLACK_LIST : 0,
      IS_LEGAL: Data.IS_LEGAL ? +Data.IS_LEGAL : 0,
    }

    if (!!yaqeenUserInfo && Object.keys(yaqeenUserInfo).length > 0) {
      getLeadDSparams.FIRST_NAME = yaqeenUserInfo.englishFirstNameField ? yaqeenUserInfo.englishFirstNameField : '';
      getLeadDSparams.MIDDLE_NAME = yaqeenUserInfo.englishSecondNameField ? yaqeenUserInfo.englishSecondNameField : '';
      getLeadDSparams.LAST_NAME = yaqeenUserInfo.englishLastNameField ? yaqeenUserInfo.englishLastNameField : '';
      getLeadDSparams.MARITAL_STATUS = yaqeenUserInfo.Marital_Status ? yaqeenUserInfo.Marital_Status : '';
      getLeadDSparams.GENDER = yaqeenUserInfo.genderField ? yaqeenUserInfo.genderField : (Data.GENDER || '');
      // getLeadDSparams.GENDER_NAME = yaqeenUserInfo.genderField == 1 ? 'male' : 'female';
    }

    if (form.controls.fullName.value) {
      const NameArray = form.controls.fullName.value.trim().split(' ');
      if (NameArray.length == 1) {
        getLeadDSparams.FIRST_NAME = NameArray[0] || '';
      }
      else if (NameArray.length > 1) {
        getLeadDSparams.FIRST_NAME = NameArray[0] || '';
        getLeadDSparams.LAST_NAME = NameArray[NameArray.length - 1] || '';
        let middleName = '';
        for (let i = 1; i < NameArray.length - 1; i++) {
          if (middleName)
            middleName += ' ' + NameArray[i];
          else
            middleName += NameArray[i];
        }
        getLeadDSparams.MIDDLE_NAME = middleName || '';
      }
    }
    return getLeadDSparams
  }

  formatNewCRMLeadObj(leadObj, isInquiry = true, isConvertToCustomer = false, OpportunityId = null, isInquiryById = false) {
    // Uncomment When We use Old Invoker
    // leadObj.inputType = Object.keys(leadObj);
    const Data = {
      "ConvertToCustomer": isConvertToCustomer,
      "IsInquiry": isInquiry,
      "IsInquiryById": isInquiryById,
      "LeadObj": leadObj,
      "OpportunityId": OpportunityId,
    }
    // Uncomment When We use Old Invoker
    // Data['inputType'] = Object.keys(Data);
    return Data;
  }

  // invokeNewCrmApi(payload) {
  //   const postData={
  //     APIUrl: 'http://192.168.0.222/crm/Services/api/Integration/LeadProcess',
  //     PayLoadObj: payload
  //   }
  //   return this.http.post('/ApiInvoker/InvokeNewCrmLead', postData);
  // }

}
